export enum SiteVisitRegardingObjectTypes {
  LR = "Licensee Return",
  CI = "CI",
  NC = "Non Compliance",
}

export interface SiteVisitsGridProps {
  regardingObjectId: string;
  regardingObjectType: SiteVisitRegardingObjectTypes;
}
